import * as React from "react";
import { Button } from "../ui/button.tsx";
import { cn } from "../utils/cn";

export type HeaderActionIntent =
  | "primary"
  | "secondary"
  | "utility"
  | "toggle"
  | "destructive";

type HeaderButtonVariant =
  | "default"
  | "secondary"
  | "outline"
  | "ghost"
  | "destructive";

const PANEL_HEADER_BUTTON_VARIANT: HeaderButtonVariant = "ghost";

export function getHeaderActionVariant(
  intent: HeaderActionIntent = "utility",
  active = false,
): HeaderButtonVariant {
  void intent;
  void active;
  return PANEL_HEADER_BUTTON_VARIANT;
}

type HeaderButtonBaseProps = Omit<
  React.ComponentProps<typeof Button>,
  "variant" | "size"
> & {
  intent?: HeaderActionIntent;
  active?: boolean;
};

/**
 * Shared header action primitives.
 * Prefer these over ad-hoc button styling in workspace header views.
 */
export function HeaderActionButton({
  intent = "utility",
  active = false,
  size = "sm",
  className,
  ...props
}: HeaderButtonBaseProps & { size?: "default" | "sm" | "lg" }) {
  return (
    <Button
      data-intent={intent}
      variant={getHeaderActionVariant(intent, active)}
      size={size}
      className={className}
      {...props}
    />
  );
}

export function HeaderIconButton({
  intent = "utility",
  active = false,
  size = "icon-sm",
  className,
  ...props
}: HeaderButtonBaseProps & { size?: "icon" | "icon-sm" | "icon-lg" }) {
  return (
    <Button
      data-intent={intent}
      variant={getHeaderActionVariant(intent, active)}
      size={size}
      className={className}
      {...props}
    />
  );
}

export function HeaderActionGroup({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("flex items-center gap-2", className)}
      {...props}
    />
  );
}
